import { render } from "./ProtectedPageView.vue?vue&type=template&id=32f77829"
import script from "./ProtectedPageView.vue?vue&type=script&lang=js"
export * from "./ProtectedPageView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__